import React, { useContext } from "react";
import { FormBuilderContext } from "../context/context";

const Decrement = ({ name, actionType }) => {
  const { dispatch } = useContext(FormBuilderContext);

  return (
    <button
      type="button"
      onClick={() =>
        dispatch({
          type: actionType,
          name,
        })
      }
      className="counter-btn counter-btn-minus"
    ></button>
  );
};

export default Decrement;
